import { mapGetters, mapMutations } from 'vuex';

import FormulaMetricsMapMixin from './formula.mixin';

import { METRIC_REGEX } from './consts';
import { getFieldLocale } from '@/utils/field';

export default {
    mixins: [FormulaMetricsMapMixin],
    methods: {
        ...mapGetters('newDashboard', ['customMetricsConverted']),
        ...mapMutations('newDashboard', ['setMetricAliases']),
        metricTranslator(name) {
            return (
                this.customMetricsConverted[name] ||
                getFieldLocale.call(this, name)
            );
        },
        formulaTranslator(formula) {
            return (formula ?? '').replace(METRIC_REGEX, (_metricKey) => {
                const metricKey = _metricKey.slice(2, -2);
                return `^*${this.metricTranslator(metricKey)}*^`;
            });
        },
        reverseFormulaTranslator(formattedFormula) {
            return (formattedFormula ?? '').replace(
                METRIC_REGEX,
                (_metricLocale) => {
                    const metricLocale = _metricLocale.slice(2, -2);
                    return `^*${
                        this.formulaMetricsMap.get(metricLocale) ?? metricLocale
                    }*^`;
                }
            );
        },
    },
};
